import React, { useEffect, useState } from "react";
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { connect } from "react-redux";
import { Dots } from "react-activity";

import { filter, map, some } from "lodash";
import moment from "moment";

import {
  createManagement,
  getManagementTypes,
  getAllManagements,
  getContactTypes,
  getCloseReasons,
  getSearchState,
  getTracking,
} from "../../../redux/actions/managementActions";
import { createOffert } from "../../../redux/actions/offeringActions";

import { after30, before30, FIRST_SECOND_EXECUTIVES, needsOffert, ROLES, SECOND_ADVISOR, today } from "../../../helper/constants";
import { isOptionAllowed, isUserAllowed } from "../../../shared/utils";
import VehicleSearchComponent from "./components/VehicleSearchComponent";
import OffertComponent from "./components/OffertComponent";
import NewGestionForm from "./components/NewGestionForm";
import AdjudgeComponent from "./components/AdjudgeComponent";

const initialManagementData = {
  managementType: '',
  trakingStatus: '',
  purchaseTerm: '',
  contactType: '',
  comment: '',
  phone: '',
  email: '',
  reason: ''
};

const initialSecondData = {
  searchState: '',
  closeReason: '',
  adjudge: '',
  adjudgedOffert: ''
};

const adjudgeSelect = [
  { id: 'ad-1', value: 'Si', label: 'Si' },
  { id: 'ad-2', value: 'No', label: 'No' },
];

const NewGestionModal = ({
  getManagementTypes,
  getAllManagements,
  createManagement,
  getCloseReasons,
  getContactTypes,
  getSearchState,
  getTracking,
  updateQuotation,
  createOffert,
  toggle,
  managementCreated,
  managementTypes,
  contactTypes,
  closeReasons,
  searchState,
  quotationId,
  tracking,
  offerts,
  phones,
  emails,
  isOpen,
  valuesHandler,
}) => {

  const hasReminder = filter(tracking.entry, (e) => e.reminder);

  const [date, setDate] = useState({ dateTask: today, time: moment().format('HH:mm') });
  const [newManagement, setData] = useState(initialManagementData);
  const [secondData, setSecondData] = useState(initialSecondData);
  const [labels, setLabels] = useState({ ...initialManagementData, ...initialSecondData });
  const [offertData, setOfferts] = useState([]);
  const [tab, setTab] = useState(ROLES.firstContactExecutive);

  const reminder = some(hasReminder, (e) => e._id === newManagement.trakingStatus);
  const whenBuy = labels.trakingStatus === '¿Cuando compra?';
  const isEmail = labels.managementType === 'Correo';
  const adjudge = labels.managementType === 'Adjudicar';
  const notFound = labels.searchState === 'No Encontrado';
  const carFound = labels.searchState === 'Encontrado';
  const noAdjugde = labels.adjudge === 'No';

  useEffect(() => { getManagementTypes(tab) }, [getManagementTypes, tab]);

  const auxManagement = (offerts.data && offerts.data.length && isUserAllowed(ROLES.salesExecutiveSc)) ? filter(managementTypes.entry, (e) => e.name !== 'Llamada') : managementTypes.entry;

  const handleCreateButton = () => {
    if (managementCreated.loading) {
      return <Dots />;
    } else if (carFound) {
      return `Guardar ${offertData.length === 1 ? 'Oferta' : 'Ofertas'}`
    } else if (newManagement.purchaseTerm === before30 || labels.reason === needsOffert) {
      return 'Actualizar Cotización'
    } else {
      return 'Crear Gestión'
    }
  }

  const handleResetGestion = () => {
    setDate({ dateTask: today, time: moment().format('HH:mm') });
    setData(initialManagementData);
    setSecondData(initialSecondData);
    setLabels({ ...initialManagementData, ...initialSecondData });
    getAllManagements(quotationId);
    toggle();
  }

  const handleSubmitManagement = (e) => {
    e.preventDefault();
    if (carFound) {
      handleCreateOffert();
    } else if (newManagement.purchaseTerm === before30 || labels.reason === needsOffert) {
      updateQuotation(null, true);
      handleCreateManagement();
    } else {
      handleCreateManagement();
    }
  }

  const handleCreateOffert = () => {
    createOffert(
      map(offertData, (e) => ({
        ...e,
        managementType: newManagement.managementType,
        searchState: secondData.searchState
      })), (status) => {
        if (status === 201) {
          handleResetGestion();
          setOfferts([]);
        }
      });
  }

  const handleCreateManagement = () => {
    createManagement({
      ...newManagement,
      ...secondData,
      callDate: (reminder || newManagement.purchaseTerm === after30) ? moment(`${date.dateTask}, ${date.time}`) : null,
      trakingStatus: newManagement.trakingStatus ? newManagement.trakingStatus : null,
      quotation: quotationId,
      comment: newManagement.comment || '-'
    }, (status) => {
      if (status === 200) handleResetGestion();
    });
  }

  const handleManagementType = (managementType, label) => {
    if (managementType !== '') {
      setData({ ...newManagement, managementType, phone: '', email: '', purchaseTerm: '' });
      label !== 'Adjudicar ' && getContactTypes(managementType, tab);
      label === 'Búsqueda de vehículo' && getSearchState(managementType);
    } else {
      setData(initialManagementData);
    }
    setSecondData(initialSecondData);
  }

  const handleContact = (contactType) => {
    if (contactType !== '') {
      setData({ ...newManagement, contactType, trakingStatus: '', purchaseTerm: '' });
      getTracking(contactType, tab);
    } else {
      setData({ ...newManagement, contactType: '', trakingStatus: '', purchaseTerm: '' });
    }
  }

  const handleTabs = (tab) => {
    setTab(tab);
    setData(initialManagementData);
    setSecondData(initialSecondData);
    setLabels({ ...initialManagementData, ...initialSecondData });
  }

  const handleIsAdmin = (tabs) => {
    if (isUserAllowed(ROLES.admin)) {
      return tabs
    }
    return true;
  }

  const handleSecondValidation = () => {
    if (isUserAllowed(ROLES.purchaseAdvisorSc)) {
      return isOptionAllowed(SECOND_ADVISOR) && labels.searchState === 'Encontrado';
    }
    if (isUserAllowed(ROLES.salesExecutiveSc)) {
      return isOptionAllowed(FIRST_SECOND_EXECUTIVES) && adjudge
    }
    return true;
  }

  const handleSaveButtonDisabled = () => {
    if (carFound) {
      return !offertData.length || managementCreated.loading
    }
    if (secondData.adjudge === 'Si') {
      return !secondData.adjudgedOffert
    }
    if (adjudge) {
      return !offerts.data
    }
    return managementCreated.loading
  }

  return (
    <Modal toggle={toggle} isOpen={isOpen} className='crm-modal-gestion-container crm-modal-new-gestion'>
      <ModalHeader toggle={toggle}>
        Nueva Gestión
        <div className="af-gold-line" />
      </ModalHeader>
      <form onSubmit={handleSubmitManagement}>
        <ModalBody>
          {isUserAllowed('admin') &&
            <div className="crm-modal-tabs">
              <button type="button" onClick={() => handleTabs(ROLES.firstContactExecutive)} disabled={tab === ROLES.firstContactExecutive}>
                Ejecutivo Primer Contacto
              </button>
              <button type="button" onClick={() => handleTabs(ROLES.salesExecutiveSc)} disabled={tab === ROLES.salesExecutiveSc}>
                Ejecutivo de Ventas
              </button>
              <button type="button" onClick={() => handleTabs(ROLES.purchaseAdvisorSc)} disabled={tab === ROLES.purchaseAdvisorSc}>
                Asesor de Compra
              </button>
            </div>
          }
          <div className="crm-modal-form-group" >
            <div className="crm-modal-input-group">
              <Label>*Tipo de Gestión</Label>
              <Input
                className='crm-modal-input-text'
                type='select'
                value={newManagement.managementType}
                disabled={managementTypes.loading || managementCreated.loading}
                onChange={(e) => {
                  handleManagementType(e.target.value, e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text);
                  setLabels({
                    ...initialManagementData,
                    ...initialSecondData,
                    managementType: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text
                  });
                }}
                required
              >
                <option key='select' value=''>
                  Seleccione
                </option>
                {map(auxManagement, (e) => (
                  <option key={e._id} value={e._id}>
                    {e.name}
                  </option>
                ))}
              </Input>
            </div>
            {!adjudge && isOptionAllowed(FIRST_SECOND_EXECUTIVES) && newManagement.managementType && handleIsAdmin(tab === ROLES.firstContactExecutive || tab === ROLES.salesExecutiveSc) &&
              <div className="crm-modal-input-group">
                <Label>*Contacto</Label>
                <Input
                  className='crm-modal-input-text'
                  type='select'
                  value={newManagement.contactType}
                  disabled={contactTypes.loading || managementCreated.loading || !contactTypes.entry || newManagement.managementType === ''}
                  onChange={(e) => {
                    handleContact(e.target.value);
                    setLabels({ ...labels, contactType: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text, trakingStatus: '' });
                  }}
                  required
                >
                  <option key='select' value=''>
                    Seleccione
                  </option>
                  {map(contactTypes.entry, (e) => (
                    <option key={e._id} value={e._id}>
                      {e.name}
                    </option>
                  ))}
                </Input>
              </div>
            }
            {isOptionAllowed(SECOND_ADVISOR) && newManagement.managementType && handleIsAdmin(tab === ROLES.purchaseAdvisorSc) &&
              <div className="crm-modal-input-group">
                <Label>Estado de Busqueda</Label>
                <Input
                  className='crm-modal-input-text'
                  type='select'
                  value={secondData.searchState}
                  disabled={managementCreated.loading || !newManagement.managementType || !searchState.entry.length}
                  onChange={(e) => {
                    setSecondData({ ...secondData, searchState: e.target.value });
                    setLabels({ ...labels, searchState: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text });
                    getCloseReasons(e.target.value);
                  }}
                  required
                >
                  <option key='select' value=''>
                    Seleccione
                  </option>
                  {map(searchState.entry, (e) => (
                    <option key={e._id} value={e._id}>
                      {e.name}
                    </option>
                  ))}
                </Input>
              </div>
            }
            {adjudge && newManagement.managementType &&
              <div className="crm-modal-input-group">
                <Label>Adjudicar</Label>
                <Input
                  className='crm-modal-input-text'
                  type='select'
                  value={secondData.adjudge}
                  disabled={!offerts.data || offerts.loading}
                  onChange={(e) => {
                    setSecondData({ ...secondData, adjudge: e.target.value, adjudgedOffert: '' });
                    setLabels({ ...labels, adjudge: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text, reason: '' });
                  }}
                >
                  <option key='select' value=''>
                    Seleccione
                  </option>
                  {map(adjudgeSelect, (e) => (
                    <option key={e.id} value={e.value}>
                      {e.label}
                    </option>
                  ))}
                </Input>
              </div>
            }
          </div>
          {isOptionAllowed(SECOND_ADVISOR) && notFound && handleIsAdmin(tab === ROLES.purchaseAdvisorSc) &&
            <VehicleSearchComponent
              labelsHandler={{ labels, setLabels }}
              secondHandler={{ secondData, setSecondData }}
              closeReasons={closeReasons}
            />
          }
          {!adjudge && newManagement.managementType && isOptionAllowed(FIRST_SECOND_EXECUTIVES) && handleIsAdmin(tab === ROLES.firstContactExecutive || tab === ROLES.salesExecutiveSc) &&
            <NewGestionForm
              newManagementHandler={{ newManagement, setData }}
              labelsHandler={{ labels, setLabels }}
              valuesHandler={valuesHandler}
              dateHandler={{ date, setDate }}
              managementCreated={managementCreated}
              reminder={reminder}
              tracking={tracking}
              whenBuy={whenBuy}
              isEmail={isEmail}
              emails={emails}
              phones={phones}
            />
          }
          {handleSecondValidation() && handleIsAdmin(tab === ROLES.purchaseAdvisorSc) &&
            <OffertComponent
              offertHandler={{ offertData, setOfferts }}
              quotationId={quotationId}
              carFound={carFound}
            />
          }
          {handleSecondValidation() && handleIsAdmin(tab === ROLES.salesExecutiveSc) &&
            <AdjudgeComponent
              newManagementHandler={{ newManagement, setData }}
              secondDataHandler={{ secondData, setSecondData }}
              labelsHandler={{ labels, setLabels }}
              valuesHandler={valuesHandler}
              noAdjugde={noAdjugde}
            />
          }
        </ModalBody>
        <ModalFooter>
          <button
            className="crm-modal-cancel-btn"
            type="button"
            disabled={managementCreated.loading}
            onClick={() => {
              setData(initialManagementData);
              setDate({ dateTask: today, time: moment().format('HH:mm') });
              setLabels({ ...initialManagementData, ...initialSecondData })
              toggle();
            }}
          >
            Cancelar
          </button>
          <button
            className="crm-modal-accept-btn"
            type="submit"
            disabled={handleSaveButtonDisabled()}
          >
            {handleCreateButton()}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

const mapStateToProps = ({ management, offering }) => ({
  managementCreated: management.managementCreated,
  managementTypes: management.managementTypes,
  contactTypes: management.contactTypes,
  closeReasons: management.closeReasons,
  searchState: management.searchState,
  tracking: management.tracking,
  offerts: offering.offerts,
});

const mapDispatchToProps = {
  createManagement,
  createOffert,
  getManagementTypes,
  getAllManagements,
  getCloseReasons,
  getContactTypes,
  getSearchState,
  getTracking,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewGestionModal);